import React from "react";
import { useLocation } from "react-router-dom";
import CalculusModuleSubtopic from "../CalculusModuleSubtopic";

const Beta = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
    <CalculusModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="Beta"
      videos={[
        "https://www.youtube.com/embed/RMcdsF_YsEY?list=PLNKD1qB9ppttGqVnTA4u9wckS6bCeLp99",
      ]}
      takeaways={[
        {
          image: "/cal_56.png"
        }
      ]}
      questions={[]}
      exampleVideos={[
        "https://www.youtube.com/embed/hX9QUklYKfM?list=PLNKD1qB9ppttGqVnTA4u9wckS6bCeLp99",
        "https://www.youtube.com/embed/I3D0MpppPV4?list=PLNKD1qB9ppttGqVnTA4u9wckS6bCeLp99",
        "https://www.youtube.com/embed/nc6EPzqOjQo?list=PLNKD1qB9ppttGqVnTA4u9wckS6bCeLp99",
      ]}
    />
  );
}

export default Beta;
